import { render, staticRenderFns } from "./taskModal.vue?vue&type=template&id=c5c34c80&scoped=true&"
import script from "./taskModal.vue?vue&type=script&lang=js&"
export * from "./taskModal.vue?vue&type=script&lang=js&"
import style0 from "./taskModal.vue?vue&type=style&index=0&id=c5c34c80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c34c80",
  null
  
)

export default component.exports